module.exports = __webpack_public_path__ + "static/media/transporter-1.5ebdd0cb.svg";